const MESSAGE_RULES = [
  [/network error/i, 'Koneksi bermasalah. Periksa jaringan atau VPN lalu coba lagi.'],
  [/timeout of \d+ms exceeded/i, 'Proses melebihi batas waktu. Coba lagi beberapa saat lagi atau gunakan file dengan jumlah data lebih kecil.'],
  [/some employees are not belong to your company scope/i, 'Karyawan tidak termasuk dalam scope perusahaan Anda. Periksa kolom Company di file atau lakukan rekonsiliasi data karyawan terlebih dahulu.'],
  [/employee already added as participant/i, 'Karyawan sudah ada di daftar peserta.'],
  [/enrollment approval is closed as today is d-1 of the training schedule/i, 'Approval enrollment ditutup karena hari ini sudah H-1 jadwal pelatihan.'],
  [/not completed in moodle/i, 'Belum selesai di Moodle.'],
  [/cannot read properties of undefined \(reading '(sheets|name)'\)/i, 'Format file tidak sesuai template. Unduh template terbaru lalu upload ulang.'],
  [/internal server error/i, 'Terjadi kendala pada server. Silakan coba lagi atau hubungi tim support.'],
  [/failed to fetch courses/i, 'Data pelatihan belum berhasil dimuat.'],
  [/failed to fetch company scopes/i, 'Daftar scope perusahaan belum berhasil dimuat.'],
  [/failed to fetch course detail/i, 'Detail pelatihan belum berhasil dimuat.'],
  [/failed to fetch batches/i, 'Data batch pelatihan belum berhasil dimuat.'],
  [/failed to fetch summary/i, 'Ringkasan data belum berhasil dimuat.'],
  [/failed to submit participants/i, 'Data peserta belum berhasil disimpan.'],
  [/failed to approve participants/i, 'Approval peserta belum berhasil diproses.'],
  [/failed to reject participants/i, 'Reject peserta belum berhasil diproses.'],
  [/failed to search employees/i, 'Pencarian karyawan belum berhasil.'],
  [/failed to fetch (mandatoried|mandatory) employees/i, 'Data karyawan mandatory belum berhasil dimuat.'],
  [/failed to fetch submitted participants/i, 'Daftar peserta pengajuan belum berhasil dimuat.'],
  [/failed to load participants/i, 'Data peserta belum berhasil dimuat.'],
  [/failed to download report/i, 'Report belum berhasil didownload.'],
  [/failed to download certificate/i, 'Sertifikat belum berhasil didownload.'],
  [/failed to download certificates/i, 'Sertifikat belum berhasil didownload.'],
  [/failed to submit certificate/i, 'Sertifikat belum berhasil dikirim.'],
  [/failed to submit reply/i, 'Balasan belum berhasil dikirim.'],
  [/failed to upload file/i, 'File belum berhasil diupload. Periksa format file lalu coba lagi.'],
  [/success/i, 'Proses selesai.'],
  [/an error occurred/i, 'Terjadi kendala. Silakan coba lagi.']
];

export function getRawErrorMessage(error, fallback = 'Terjadi kendala. Silakan coba lagi.') {
  if (typeof error === 'string') {
    return error;
  }

  return error?.response?.data?.error
    || error?.response?.data?.message
    || error?.message
    || fallback;
}

export function getBatchMutationErrorMessage(error, fallback = 'Batch belum berhasil diproses') {
  const rawMessage = String(getRawErrorMessage(error, fallback) || fallback);
  const isTimeout = error?.code === 'ECONNABORTED'
    || /timeout of \d+ms exceeded/i.test(rawMessage);

  if (isTimeout) {
    return 'Clone course Moodle melebihi batas waktu. Proses bisa memakan waktu hingga 5 menit. Silakan coba lagi.';
  }

  return rawMessage;
}

export function normalizeErrorMessage(error, fallback = 'Terjadi kendala. Silakan coba lagi.') {
  const rawMessage = String(getRawErrorMessage(error, fallback) || fallback);
  const rule = MESSAGE_RULES.find(([pattern]) => pattern.test(rawMessage));

  return rule ? rule[1] : rawMessage;
}

export function buildScopedCompanyMessage(item) {
  const baseMessage = normalizeErrorMessage(item?.message || item?.reason || item);
  const companyInDb = item?.db_company || item?.company_in_db || item?.employee_company || item?.company;
  const allowedCompany = item?.allowed_company || item?.submitted_by_company || item?.scope_company;

  if (!/scope perusahaan/i.test(baseMessage)) {
    return baseMessage;
  }

  const detail = [];
  if (companyInDb) {
    detail.push(`Company di DB: ${companyInDb}`);
  }
  if (allowedCompany) {
    detail.push(`Scope upload: ${allowedCompany}`);
  }

  return detail.length ? `${baseMessage} (${detail.join(' | ')})` : baseMessage;
}
